import { Action, Dispatch, bindActionCreators } from 'redux';
import { Claims, StateProps, DispatchProps } from '../components/claim/Claims';
import { generateClaim, refreshClaim, resetClaim, submitClaim } from '../redux/claim/actions';
import { onPageDidMount, onPageWillUnmount } from '../redux/core';
import { setClaimStatus, setClaimsSearchText, setClaimsFromDate, setClaimsToDate } from '../redux/ui/actions';

import { RootState } from '../redux/types';
import { connect } from 'react-redux';
import { withRouter } from '../util/Router';

export function mapStateToProps(state: RootState): StateProps {
  return {
    claims: state.claims.claims,
    claimsStatus: state.ui.claimsStatus,
    claimsSearchText: state.ui.claimsSearchText,
    optionKeyDepressed: state.ui.optionKeyDepressed,
    claimsFromDate: state.ui.claimsFromDate,
    claimsToDate: state.ui.claimsToDate,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<Action>): DispatchProps {
  return {
    actions: bindActionCreators(
      {
        onPageDidMount,
        onPageWillUnmount,
        setClaimStatus,
        setClaimsSearchText,
        generateClaim,
        submitClaim,
        refreshClaim,
        resetClaim,
        setClaimsFromDate,
        setClaimsToDate,
      },
      dispatch
    ),
  };
}

export const ClaimsContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(Claims));
